import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import BoltIcon from '@mui/icons-material/Bolt';
import TimelineIcon from '@mui/icons-material/Timeline';

interface PlmAbortDialogProps {
  open: boolean;
  onClose: () => void;
  onAbortCurrent: () => void;
  onAbortAll: () => void;
  onViewSchedule: () => void;
  deviceName: string;
}

export function PlmAbortDialog({
  open,
  onClose,
  onAbortCurrent,
  onAbortAll,
  onViewSchedule,
  deviceName,
}: PlmAbortDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <BoltIcon color="warning" />
          <Typography variant="h6">PLM Event Response Active</Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" paragraph>
          The device <strong>{deviceName}</strong> is currently participating in
          a PLM event response.
        </Typography>
        <Typography variant="body1" paragraph>
          You can choose to:
        </Typography>
        <Box ml={2}>
          <Typography variant="body2" paragraph>
            • <strong>Cancel this cycle only</strong> - Stop the current PLM
            cycle and allow future cycles to continue
          </Typography>
          <Typography variant="body2" paragraph>
            • <strong>Cancel all remaining cycles</strong> - Stop all future PLM
            cycles for this device in this event
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          Note: Canceling will restore the device to its previous state.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
        <Button
          onClick={onAbortCurrent}
          variant="outlined"
          sx={{
            color: '#d32f2f', // Dark red text
            borderColor: '#d32f2f', // Dark red border
            '&:hover': {
              backgroundColor: 'rgba(211, 47, 47, 0.04)', // Light red background on hover
              borderColor: '#b71c1c', // Darker red border on hover
            },
          }}
        >
          Cancel This Cycle
        </Button>
        <Button onClick={onAbortAll} color="error" variant="contained">
          Cancel All Remaining
        </Button>
        <Button onClick={onViewSchedule} color="info" variant="outlined">
          View PLM Schedule
        </Button>
      </DialogActions>
    </Dialog>
  );
}
